// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NT45g4W514DDtCpGfPpI {
  display: flex;
  flex-direction: column;
  transition: transform 1s ease;
  width: 50%;
}

.cJ9ampxBB9DSLLnAN2FC{
  display: flex;
  flex: 1;
}

.NC8XLE8PRrxPO8Te8ERb {
  display: flex;
  justify-content: end;
  align-items: center;
}

 
`, "",{"version":3,"sources":["webpack://./src/Calendar.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,6BAA6B;EAC7B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,OAAO;AACT;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,mBAAmB;AACrB","sourcesContent":[".page {\n  display: flex;\n  flex-direction: column;\n  transition: transform 1s ease;\n  width: 50%;\n}\n\n.item{\n  display: flex;\n  flex: 1;\n}\n\n.meetingTypeSelector {\n  display: flex;\n  justify-content: end;\n  align-items: center;\n}\n\n \n"],"sourceRoot":""}]);
// Exports
export var page = `NT45g4W514DDtCpGfPpI`;
export var item = `cJ9ampxBB9DSLLnAN2FC`;
export var meetingTypeSelector = `NC8XLE8PRrxPO8Te8ERb`;
export default ___CSS_LOADER_EXPORT___;
